import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import { DownloadButton } from "components/buttons";
import useRoomTemplateFilePath from "./use-room-template-file-path";

const DownloadRoomTemplate = ({ roomTemplate, onlyIcon, intl }) => {
  const downloadUrl = useRoomTemplateFilePath({
    id: roomTemplate.id,
    contractId: roomTemplate.contractId,
  });

  return roomTemplate && <DownloadButton onlyIcon={onlyIcon} url={downloadUrl} />;
};

DownloadRoomTemplate.propTypes = {
  /**
   * Data to represent
   **/
  roomTemplate: PropTypes.object,
  /**
   * Shows as a simple icon
   **/
  onlyIcon: PropTypes.bool,
};

export default injectIntl(DownloadRoomTemplate);
